module.exports = __webpack_public_path__ + "static/media/issue-grey.cbe2b827.svg";